var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 14.6875H1.875C1.49375 14.6875 1.12812 14.536 0.858534 14.2665C0.58895 13.9969 0.4375 13.6312 0.4375 13.25V1.75C0.4375 1.36875 0.58895 1.00312 0.858534 0.733534C1.12812 0.46395 1.49375 0.3125 1.875 0.3125H14.0938C14.475 0.3125 14.8406 0.46395 15.1102 0.733534C15.3798 1.00312 15.5312 1.36875 15.5312 1.75V4.66813L19.4269 1.88656C19.5341 1.81018 19.6603 1.76474 19.7917 1.7552C19.923 1.74566 20.0545 1.77239 20.1717 1.83246C20.2888 1.89254 20.3873 1.98366 20.4562 2.09587C20.5251 2.20808 20.5619 2.33706 20.5625 2.46875V12.5312C20.5619 12.6629 20.5251 12.7919 20.4562 12.9041C20.3873 13.0163 20.2888 13.1075 20.1717 13.1675C20.0545 13.2276 19.923 13.2543 19.7917 13.2448C19.6603 13.2353 19.5341 13.1898 19.4269 13.1134L15.5312 10.3319V13.25C15.5312 13.6312 15.3798 13.9969 15.1102 14.2665C14.8406 14.536 14.475 14.6875 14.0938 14.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraWhite);
export default __webpack_public_path__ + "static/media/cameraWhite.7ead265d5e014b9644fe516dd6d58299.svg";
export { ForwardRef as ReactComponent };